export default __webpack_public_path__ + "static/media/icon-hand.5abb802c.svg";